import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { EPAWorklistDetails } from "../../Apis/AuthApiServices";
import {
  loadingEPAWorklistDetails,
  setEPAWorklistDetails,
} from "../Slice/EPAWorklistDetailsSlice";

function* onLoadEPAWorklistDetailsAsync({ payload }: any) {
  const params = new URLSearchParams();
  params.append("doctorId", payload.doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  params.append("prescriptionType", payload.prescriptionType);
  try {
    const result: AxiosResponse = yield EPAWorklistDetails(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setEPAWorklistDetails({
          EPAWorklistDetailsData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setEPAWorklistDetails({
          EPAWorklistDetailsData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setEPAWorklistDetails({
        EPAWorklistDetailsData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadEPAWorklistDetails() {
  yield takeLatest(
    loadingEPAWorklistDetails.type,
    onLoadEPAWorklistDetailsAsync
  );
}

const EPAWorklistDetailsSaga = [fork(onLoadEPAWorklistDetails)];
export default EPAWorklistDetailsSaga;
